import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/groupCreationForm/resourcesList/resource/styles.scss';export default {
  "resource": "_resource_1cybo_1",
  "icon": "_icon_1cybo_26",
  "removeResourceIconContainer": "_removeResourceIconContainer_1cybo_38"
};